import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('email');

export class Notifications extends Api {
    constructor(http, config = {}) {
      super(http, url, 'email', config);
    }

    notifyAdvisorOfNewDocumentation(studentCareerId){
        return this._http.post(`${this._baseUrl}/studentCareers/${studentCareerId}/new-documents`);
    }

  }
  